import {
  Box,
  Paper,
  Tab,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Tabs,
  Tooltip,
} from "@mui/material";
import { Icons, Images } from "assets";
import classNames from "classnames";
import { useState } from "react";
import RangeDatePicker from "shared/components/rangeDatePicker";
import useWindowSize from "shared/customHooks/windowSize";
import styles from "./style.module.scss";
import { useLocation } from "react-router-dom";
import useBreadcrumbs from "shared/customHooks/useBreadCrumbs";
import { routeConstant } from "shared/routes/routesConstant";

function AllPartnersListings() {
  const screenWidth = useWindowSize();
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const usersStatus: any = queryParams.get("users");
  const [activeTab, setActiveTab] = useState<any>(0);
  const [startDate, setStartDate] = useState<Date | null>(null);
  const [endDate, setEndDate] = useState<Date | null>(new Date());

  let partnersDetail = [
    {
      name: "Jake Paul",
      email: "jakepaul@yopmail.com",
      status: 1,
      phone: "030100201211",
    },
    {
      name: "Emma Stone",
      email: "emmastone@yopmail.com",
      status: 0,
      phone: "030100322312",
    },
    {
      name: "Kate Wilson",
      email: "katewilson@yopmail.com",
      status: 1,
      phone: "030100322212",
    },
  ];

  const tabs = [
    {
      value: 0,
      label: "Publishers Accounts",
    },
    {
      value: 1,
      label: "Authors Accounts",
    },
  ];

  const handleChange = (event: any, newValue: number) => {
    setActiveTab(newValue);
  };

  useBreadcrumbs(
    {
      title: `${
        usersStatus === "pending" ? "Pending Parnters" : "Approved Parnters"
      }`,
      path: routeConstant.partnerListings.path,
    },
    true
  );

  return (
    <div className={styles.mainContainer}>
      <div>
        <Box className={styles.headingContainer}>
          <div>
            <span className={styles.heading}>
              {usersStatus === "pending" ? "Pending" : "Approved"} Partners
              Account
            </span>
          </div>

          <div className={styles.dateContainer}>
            <RangeDatePicker
              startDate={startDate}
              setStartDate={setStartDate}
              endDate={endDate}
              setEndDate={setEndDate}
              doubleLabel={true}
            />
          </div>
        </Box>
      </div>
      <div className={styles.mainTableContainer}>
        <Box className={styles.topHeadingContainer}>
          <div>
            <div className={styles.tableHeading}>
              {" "}
              {usersStatus === "pending" ? "Pending" : ""} Partners Accounts
            </div>
            <div className={styles.subHeading}>
              Manage your {usersStatus === "pending" ? "pending" : "approved"}{" "}
              partner's accounts here.
            </div>
          </div>
          <div className={styles.btnContainer}>
            <div className={styles.searchInputContainer}>
              <Icons.SearchIcon2 className={styles.searchIcon} />
              <input className={styles.seachInput} placeholder="Search" />
            </div>
            <button className={styles.filterBtn}>
              <Icons.FilterIcon /> Filter
            </button>
          </div>
        </Box>

        <Box className={styles.boxContainer}>
          <Tabs
            value={activeTab}
            onChange={handleChange}
            className={styles.tab}
            TabIndicatorProps={{
              style: {
                backgroundColor: "black",
              },
            }}
            sx={{ background: "white", padding: "0px 14px" }}
          >
            {tabs?.map((item: any, index: any) => {
              return (
                <Tab
                  label={
                    <div
                      className={classNames(
                        styles.tabs,
                        activeTab === item?.value && styles.active
                      )}
                    >
                      <label className={styles.tabLabel}> {item?.label}</label>
                    </div>
                  }
                  sx={{ padding: "0px" }}
                />
              );
            })}
          </Tabs>
        </Box>

        <TableContainer
          component={Paper}
          sx={screenWidth > 990 ? { width: `${screenWidth - 300}px` } : {}}
          className={styles.tableContainer}
          id="table-view-dashboard"
        >
          <Table>
            <TableHead className={styles.tableHead}>
              <TableRow>
                <TableCell>Name</TableCell>
                <TableCell>Earnings</TableCell>
                <TableCell>MOU</TableCell>
                <TableCell>Books Published</TableCell>
                <TableCell>Linked Accounts</TableCell>
                <TableCell>Actions</TableCell>
              </TableRow>
            </TableHead>
            <TableBody className={styles.tableBody}>
              {partnersDetail?.map((item: any, index: number, arr: any[]) => {
                return (
                  <TableRow
                    className={classNames(
                      index + 1 === arr?.length && styles.noBorder
                    )}
                  >
                    <TableCell
                      sx={{
                        display: "flex",
                        gap: "10px",
                        alignItems: "center",
                      }}
                    >
                      <div
                        style={{
                          display: "flex",
                          gap: "10px",
                          alignItems: "center",
                        }}
                      >
                        <img
                          src={Images.UserPlaceholderImage}
                          alt="profile_picture"
                          className={styles.profilepic}
                        />
                        <div
                          style={{ display: "flex", flexDirection: "column" }}
                        >
                          <label>{item?.name}</label>
                          <label className={styles.publishingHouse}>
                            Publishing House
                          </label>
                        </div>
                      </div>
                    </TableCell>
                    <TableCell>Rs 40,000</TableCell>
                    <TableCell>Signed</TableCell>
                    <TableCell>320</TableCell>
                    <TableCell>04</TableCell>
                    <TableCell>
                      <div className={styles.actionContainer}>
                        <Tooltip arrow title="View">
                          <div>
                            <Icons.EyeIcon />
                          </div>
                        </Tooltip>
                        <Tooltip arrow title={"Create MOU"}>
                          <div>
                            <Icons.PartnersIcon
                              style={{ width: "18px", height: "18px" }}
                            />
                          </div>
                        </Tooltip>
                        <Tooltip arrow title={"Support Chat"}>
                          <div>
                            <Icons.MsgActionIcon
                              style={{ width: "18px", height: "18px" }}
                            />
                          </div>
                        </Tooltip>
                        <Tooltip
                          arrow
                          title={item?.status ? "Deactivate" : "Activate"}
                        >
                          <div>
                            {item?.status ? (
                              <Icons.UserDeactivate
                                className={classNames(
                                  styles.icons,
                                  styles.deactive
                                )}
                              />
                            ) : (
                              <Icons.UserActivate
                                className={classNames(
                                  styles.icons,
                                  styles.active
                                )}
                              />
                            )}
                          </div>
                        </Tooltip>
                      </div>
                    </TableCell>
                  </TableRow>
                );
              })}
            </TableBody>
          </Table>
        </TableContainer>
      </div>
    </div>
  );
}

export default AllPartnersListings;
